// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CustomizedSelect_arrow__2raz4"};